module.exports = __webpack_public_path__ + "img/successbadge.20d4ba60.svg";